// export type SexEnum = 'M' | 'F' | 'U'

export enum LoginSolicitorType {
  PO_Transfer = 'PO-T',
  PO_Loan = 'PO-L',
  CO_Transfer = 'CO-T',
  CO_Loan = 'CO-L',
  CO_Outgoing = 'CO-O',
}
